import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { invoiceFeatureKey, invoiceReducer } from './invoice-reducer';
import { InvoiceEffects } from './effects/invoice.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(invoiceFeatureKey, invoiceReducer),
        EffectsModule.forFeature([InvoiceEffects])
    ]
})
export class InvoiceStoreModule {}
